import ProductCategory from "./ProductCategory";
import Product from "./Product";
import ImportProduct from "./ImportProduct";
import Inward from "./Inward";
import Outward from "./Outward";
import Stock from "./Stock";
import StockSummary from "./StockSummary";
import Quality from "./Quality";
import Report from "./Report";
import MachineryShop from "./MachineryShop";
import ProductDashboard from "./ProductDashboard";

const productRoutes = [
  {
    path: "/product/dashboard",
    element: <ProductDashboard />,
  },
  {
    path: "/product/product-category",
    element: <ProductCategory />,
  },
  {
    path: "/product/products",
    element: <Product />,
  },
  {
    path: "/product/import",
    element: <ImportProduct />,
  },
  {
    path: "/product/inward",
    element: <Inward />,
  },
  {
    path: "/product/outward",
    element: <Outward />,
  },
  {
    path: "/product/stock",
    element: <Stock />,
  },
  {
    path: "/products-stock",
    element: <StockSummary />,
  },
  {
    path: "/product/quality",
    element: <Quality />,
  },
  {
    path: "/product/report",
    element: <Report />,
  },
  {
    path: "/product/machinery-shop",
    element: <MachineryShop />,
  },
];

export default productRoutes;
